export const LOCATION_OPTIONS = [
  { label: "台灣 (Taiwan)", value: 2158 },
  { label: "美國 (United States)", value: 2840 },
  { label: "日本 (Japan)", value: 2392 },
  { label: "韓國 (South Korea)", value: 2410 },
  { label: "中國 (China)", value: 2156 },
  { label: "香港 (Hong Kong)", value: 2344 },
  { label: "新加坡 (Singapore)", value: 2702 },
  { label: "馬來西亞 (Malaysia)", value: 2458 },
  { label: "澳洲 (Australia)", value: 2036 },
  { label: "英國 (United Kingdom)", value: 2826 },
  { label: "加拿大 (Canada)", value: 2124 },
  { label: "德國 (Germany)", value: 2276 },
  { label: "法國 (France)", value: 2250 },
  { label: "印度 (India)", value: 2356 },
  { label: "泰國 (Thailand)", value: 2764 },
  { label: "越南 (Vietnam)", value: 2704 },
  { label: "印尼 (Indonesia)", value: 2360 },
  { label: "菲律賓 (Philippines)", value: 2608 },
] as const;

export const LANGUAGE_OPTIONS = [
  { label: "繁體中文 (Chinese Traditional)", value: "zh-TW" },
  { label: "簡體中文 (Chinese Simplified)", value: "zh-CN" },
  { label: "英文 (English)", value: "en" },
  { label: "日文 (Japanese)", value: "ja" },
  { label: "韓文 (Korean)", value: "ko" },
  { label: "泰文 (Thai)", value: "th" },
  { label: "越南文 (Vietnamese)", value: "vi" },
  { label: "馬來文 (Malay)", value: "ms" },
  { label: "法文 (French)", value: "fr" },
  { label: "德文 (German)", value: "de" },
  { label: "西班牙文 (Spanish)", value: "es" },
  { label: "印尼文 (Indonesian)", value: "id" },
] as const;

export const DEFAULT_LOCATION = 2158; // Taiwan
export const DEFAULT_LANGUAGE = "zh-TW";
